import React from 'react';
import Navbar from './Navbar';
import { useNavigate } from 'react-router-dom';

const TerminosCondiciones: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Navbar currentTheme={1} onThemeChange={() => {}} />
      <div className="min-h-screen w-full bg-gradient-to-br from-yellow-200 via-yellow-100 to-blue-200">
        <div className="container mx-auto px-4 py-8 max-w-4xl">
          <div className="bg-white rounded-3xl shadow-2xl p-6 md:p-8 mt-20">
            <div className="flex justify-between items-center mb-6">
              <h1 className="text-3xl md:text-4xl font-bold text-yellow-700">
                TÉRMINOS Y CONDICIONES
              </h1>
              <button
                onClick={() => navigate('/explorer')}
                className="bg-yellow-400 hover:bg-yellow-500 text-white font-bold py-2 px-4 rounded-full transition"
              >
                Volver al Formulario
              </button>
            </div>
            
            <h2 className="text-2xl font-bold mb-6 text-center">
              PROGRAMA "PRINCONSER EXPLORER"
            </h2>
            
            <p className="mb-6 text-gray-700">
              Este documento regula la participación en el Programa Piloto "Princonser Explorer" 
              ("Programa") ofrecido por Multitest Solutions LLC d/b/a Princonser Kids ("Organización").
            </p>

            <div className="space-y-6 text-gray-700">
              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">1. PARTES</h3>
                <ul className="list-disc pl-6 space-y-2">
                  <li><strong>Organización:</strong> Multitest Solutions LLC d/b/a Princonser Kids.</li>
                  <li><strong>Participantes:</strong> Representantes legales de menores de 6–15 años ("Padres") y los niños inscritos ("Niños").</li>
                </ul>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">2. OBJETO</h3>
                <p>
                  Estos Términos y Condiciones ("T&C") establecen las reglas para la recogida, uso y protección 
                  de los datos facilitados por los Padres al inscribirse y participar en el Programa Princonser 
                  Explorer, así como los derechos y obligaciones de las partes.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">3. DATOS PERSONALES Y FINALIDADES</h3>
                <div className="overflow-x-auto">
                  <table className="w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-yellow-100">
                        <th className="border border-gray-300 p-2 text-left">Datos Recogidos</th>
                        <th className="border border-gray-300 p-2 text-left">Finalidad</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="border border-gray-300 p-2">Nombre del Representante</td>
                        <td className="border border-gray-300 p-2">Registro y contacto</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 p-2">País de Residencia</td>
                        <td className="border border-gray-300 p-2">Estadísticas de alcance</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 p-2">Teléfono y Correo</td>
                        <td className="border border-gray-300 p-2">Comunicaciones y soporte</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 p-2">Número, Nombre y Edad de los Niños</td>
                        <td className="border border-gray-300 p-2">Personalización del libro, análisis interno</td>
                      </tr>
                      <tr>
                        <td className="border border-gray-300 p-2">Foto de los Niños (opcional)</td>
                        <td className="border border-gray-300 p-2">Personalización de ejemplares físicos</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <p className="mt-3">
                  Los datos se usarán exclusivamente para análisis interno, mejora del Programa y 
                  personalización de ejemplares.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">4. CESIÓN Y COMPARTICIÓN DE DATOS</h3>
                <p>
                  La Organización no transmitirá datos a terceros, salvo para el funcionamiento del chatbot (p.ej. 
                  N8N), siempre bajo estrictas políticas de confidencialidad y encriptación.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">5. PLAZO DE RETENCIÓN</h3>
                <p>
                  Los datos se conservarán durante el tiempo necesario para cumplir con las finalidades descritas 
                  y, en todo caso, conforme a la Ley de Protección de Datos de Florida, como máximo 5 años 
                  desde la finalización del Programa.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">6. CONSENTIMIENTOS Y DERECHOS</h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li><strong>Consentimiento informado:</strong> Al marcar "Acepto los T&C" los Padres autorizan el tratamiento de datos según este documento.</li>
                  <li><strong>Publicación de testimonios e imágenes:</strong> Se autoriza la posible publicación de nombre e imagen de los Niños en materiales promocionales, sitios web y redes sociales.</li>
                  <li><strong>Revocación:</strong> Los Padres pueden retirar su consentimiento total o parcial en cualquier momento enviando email a info@princonserkids.com o WhatsApp 305-518 5322.</li>
                </ol>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">7. PROPIEDAD INTELECTUAL Y DERECHOS DE IMAGEN</h3>
                <ol className="list-decimal pl-6 space-y-2">
                  <li><strong>Titularidad:</strong> La Organización retiene todos los derechos sobre materiales del Programa y el contenido generado por Niños y Padres (textos, fotos, vídeos, ideas).</li>
                  <li><strong>Logos y licencias de terceros:</strong> Se cuenta con licencias válidas de ESIC Emprendedores, Foro Mundial de Filosofía y Universidad Princonser para el uso de sus marcas e ilustraciones.</li>
                </ol>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">8. OBLIGACIONES</h3>
                <div className="space-y-3">
                  <div>
                    <strong>Organización:</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Entregar los libros físicos y personalizados.</li>
                      <li>Brindar soporte técnico y pedagógico durante 3 semanas.</li>
                      <li>Respetar confidencialidad y privacidad.</li>
                      <li>Entregar los premios (serie completa gratis, curso, testimonios) solo si se cumplen las tareas en plazo.</li>
                    </ul>
                  </div>
                  <div>
                    <strong>Padres:</strong>
                    <ul className="list-disc pl-6 mt-2 space-y-1">
                      <li>Facilitar datos veraces.</li>
                      <li>Supervisar las actividades de los Niños.</li>
                      <li>Completar encuestas semanales y subir fotos al dashboard.</li>
                      <li>Finalizar el Programa en máximo 3 semanas.</li>
                    </ul>
                  </div>
                </div>
                <p className="mt-3">
                  El incumplimiento faculta a la Organización a denegar premios sin reclamación posterior.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">9. LIMITACIÓN DE RESPONSABILIDAD</h3>
                <p>La Organización no será responsable de:</p>
                <ul className="list-disc pl-6 mt-2 space-y-1">
                  <li>Daños físicos o emocionales que pudieran derivarse de la ejecución de actividades.</li>
                  <li>Uso indebido de la plataforma web o de los contenidos.</li>
                </ul>
                <p className="mt-3">
                  Los Padres asumen el riesgo de supervisar y realizar las actividades en un entorno seguro.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">10. INDEMNIZACIÓN</h3>
                <p>
                  Las partes acuerdan indemnizarse recíprocamente frente a reclamaciones de terceros por 
                  incumplimientos de estos T&C o por daños derivados de su conducta.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">11. CONDICIONES TÉCNICAS</h3>
                <p>
                  El Programa operará en https://princonserkids.com/ a partir de la fecha de aceptación de estos 
                  T&C. Cualquier actualización se notificará en la plataforma durante el onboarding y requerirá 
                  nuevo "tick" de aceptación para seguir participando.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">12. JURISDICCIÓN Y LEY APLICABLE</h3>
                <p>
                  Estos T&C se rigen por la Ley del Estado de Florida (USA). Para cualquier controversia, las 
                  partes se someten a la jurisdicción de los tribunales de Florida, previa mediación o arbitraje 
                  conforme a las normas aplicables.
                </p>
              </section>

              <section>
                <h3 className="text-xl font-bold mb-3 text-yellow-700">13. PRIVACIDAD Y SEGURIDAD</h3>
                <p>
                  La Organización adopta acceso restringido a los datos y medidas de protección razonables. En 
                  caso de brecha, notificará a los Padres y autoridades competentes en un plazo máximo de 72 
                  horas según la legislación aplicable.
                </p>
              </section>

              <div className="bg-yellow-50 p-4 rounded-lg border-l-4 border-yellow-400 mt-6">
                <p className="font-semibold text-gray-800">
                  Al enviar el formulario y marcar "Acepto los Términos y Condiciones", usted declara que 
                  ha leído, entendido y acepta todas las cláusulas aquí expuestas.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TerminosCondiciones; 